import type {
    SupplierListQuery,
    SupplierPaymentsQuery,
    SupplierStatementQuery,
} from '@/api/handlers/resources/suppliers/requests';

/**
 * Centralised TanStack Query keys for the Suppliers resource. Sharing the
 * keys here keeps mutations and queries from drifting out of step when one is
 * invalidated and the other is read.
 *
 * `details()` is the prefix that covers every paginated page; `detailsPage`
 * adds the query params so each page/search is its own cache entry. `picker`
 * is the separate unpaginated dropdown list. Write mutations invalidate
 * `all` so both the pages and the picker refetch.
 */
export const SupplierQueryKeys = {
    all: ['suppliers'] as const,
    list: () => [...SupplierQueryKeys.all, 'list'] as const,
    details: () => [...SupplierQueryKeys.all, 'details'] as const,
    detailsPage: (query: SupplierListQuery) =>
        [...SupplierQueryKeys.details(), query] as const,
    picker: () => [...SupplierQueryKeys.all, 'picker'] as const,
    payments: (id: string) =>
        [...SupplierQueryKeys.all, 'payments', id] as const,
    paymentsPage: (id: string, query: SupplierPaymentsQuery) =>
        [...SupplierQueryKeys.payments(id), query] as const,
    statement: (id: string, query: SupplierStatementQuery) =>
        [...SupplierQueryKeys.all, 'statement', id, query] as const,
};
